import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { map, take } from 'rxjs/operators';
import { ASSET_CONSTANTS } from '../../../shared/constants/asset-constants';
import { selectAuthUser } from '../../../store/auth/auth.selectors';
import { MbButtonComponent } from '../mb-button/mb-button.component';

@Component({
  selector: 'app-mb-modal',
  standalone: true,
  imports: [NzModalModule, MbButtonComponent, CdkScrollable],
  templateUrl: './mb-modal.component.html',
  styleUrls: ['./mb-modal.component.scss'],
})
export class MbModalComponent {
  @Input() title = '';
  @Input() icon?: string;
  @Input() isVisible = false;
  @Input() okText = 'OK';
  @Input() width = '760px';
  @Input() mobileWidth = '95%';
  @Input() desktopWidth = '760px';
  @Input() maskOpacity = 0.7;
  @Input() okDisabled = false;
  @Input() loading = false;

  @Input() alternativeActionButtonText = '';
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() OkActionHandler = new EventEmitter<void>();
  @Output() CancelActionHandler = new EventEmitter<void>();
  @Output() alternativeActionHandler = new EventEmitter<void>();

  cancelDisabled = true;

  constructor(
    private store: Store,
    private router: Router,
  ) {}

  get responsiveWidth(): string {
    return window.innerWidth < 800 ? this.mobileWidth : this.desktopWidth;
  }

  protected readonly ASSET_CONSTANTS = ASSET_CONSTANTS;

  showModal(): void {
    this.store
      .select(selectAuthUser)
      .pipe(
        take(1),
        map((user) => {
          if (!user) {
            this.router.navigate(['/auth']);
            return false;
          }

          this.isVisible = true;
          this.isVisibleChange.emit(true);
          return true;
        }),
      )
      .subscribe();
  }

  onCancel(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
    this.CancelActionHandler.emit();
  }

  onOk(): void {
    this.OkActionHandler.emit();
  }
}
